import { z } from "@/zod";

export const roleId = z.string().length(26);
